import { render, staticRenderFns } from "./mobile-header-primary.vue?vue&type=template&id=2f157b06&"
import script from "./mobile-header-primary.vue?vue&type=script&lang=js&"
export * from "./mobile-header-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports